import React from "react";
import { getClassName } from "@utils";
import { Tooltip, TooltipSize } from "../Tooltip";
import css from "./AnalysisItem.module.scss";

export interface AnalysisItemProps {
  title?: string;
  children?: React.ReactNode;
  isLoading?: boolean;
  tooltip?: string;
}

const AnalysisItem: React.FC<AnalysisItemProps> = ({ title, children, isLoading, tooltip }) => {
  const attrs = {
    container: {
      className: getClassName(css.container, isLoading && css.containerLoading),
    },
    title: {
      className: css.title,
    },
    tooltip: {
      disabled: isLoading,
      size: TooltipSize.XS,
      text: tooltip,
      arrow: false,
      autoPosition: true,
      width: 232,
      positionOverride: {
        left: 16,
      },
    },
    content: {
      className: css.content,
    },
  };

  return (
    <div {...attrs.container}>
      {title ? (
        <div {...attrs.title}>
          <span>{title}</span>
          {tooltip ? <Tooltip {...attrs.tooltip} /> : null}
        </div>
      ) : null}
      {children ? <div {...attrs.content}>{children}</div> : null}
    </div>
  );
};

export default AnalysisItem;
